import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  standalone: true,
  name: 'multiply'
})
export class MultiplyPipe implements PipeTransform {
  transform(value: number, multiplier: number) {
    return value * multiplier;
  }
}

